import styled from 'styled-components';

export const Content = styled.label`
  &.multi {
    cursor: pointer;
    display: flex;
    align-items: center;
    margin: 0 0 10px;
    opacity: 1;
    &:last-child {
      margin-bottom: 0;
    }
  }
  &.item-all{
    font-weight: bold;
  }
  input {
    border: solid 1px #bebebe;
    padding: 0;
    margin-right: 15px;
    appearance: none;
    outline: none;
    cursor: pointer;
    width: 14px;
    height: 14px;
    border-radius: 4px;
    opacity: 1;
    &:checked {
      background-image: url('/images/checkbox-checked.png');
      background-size: cover;
      background-repeat: no-repeat;
      background-color: #fff;
      border: none;
    }
  }
  span {
    display: block;
    font-size: 15px;
    line-height: normal;
  }
`;
